import { useEffect, useState, FC } from "react";
import WR360 from "@webrotate360/imagerotator";

import { getWebRotate } from "../../services/webRotate.service";
import { WebRotateResponseTypes } from "../../types/response";
import { TIMEOUT_VIEW } from "../../commons/constants/variables";
import Loading from "../../commons/components/Loading";

import "./styles.scss";

type WebRotatePropsType = {
  code?: string;
  language?: string;
};

const WebRotate: FC<WebRotatePropsType> = (props: WebRotatePropsType) => {
  const { code, language } = props;
  const [dataWedRotate, setDataWedRotate] = useState<WebRotateResponseTypes>();
  const [loading, setLoading] = useState(false);

  const getDateWebRotate = async () => {
    setLoading(true);
    const data = await getWebRotate(code, language);
    setDataWedRotate(data);
  };

  useEffect(() => {
    if (code) {
      getDateWebRotate();
    }
  }, [code]);

  useEffect(() => {
    if (!dataWedRotate) return;
    const viewer = WR360.ImageRotator.Create(`clik-webrotate-${code}`);
    let viewerApi;
    viewer.licenseFileURL = process.env.REACT_APP_WEBTOTATE_KEY;
    viewer.settings.configFileURL = dataWedRotate?.configFile?.url;
    viewer.settings.graphicsPath =
      dataWedRotate?.sourceFolder?.url &&
      `${dataWedRotate.sourceFolder.url}/imagerotator/html/img/basic`;

    viewer.settings.apiReadyCallback = (api) => {
      setLoading(false);
      let callback;
      viewerApi = api;
      viewerApi.hotspots.onAction((hotspot) => {
        const { id } = hotspot;
        if (callback) {
          callback(id);
        }
      });
      // debug api webtotate
      // window["rotateApi"] = api;

      // call back function when click hotspot
      window.onClickHotspots = (funcCallback) => {
        callback = funcCallback;
      };

      // call api function when api webrotate ready
      if (window.onWebRotateLoaded) {
        const hotspots =
          viewerApi.hotspots && viewerApi.hotspots.getDynamicHotspots();
        const idsHotspots = (hotspots || []).map(
          (item) => item.hotspotConfig.id
        );

        // return list id hotspots
        window.onWebRotateLoaded(idsHotspots);
      }

      if (window.onWebRotateDrag) {
        viewerApi?.images?.onDrag(() => {
          window.onWebRotateDrag();
        });
      }
    };
    viewer.runImageRotator();
    window.onDestroyWebRotate = () => {
      // Destroy viewer instance when not needed
      if (viewerApi) viewerApi.delete();
    };

    window.updateDimensions = () => {
      // update dimensions web rotate
      if (viewerApi) viewerApi.updateDimensions();
    };

    // active hotspots
    window.gotoHotspots = (hotspotsName, timeoutView = TIMEOUT_VIEW) => {
      if (!viewerApi) return;
      viewerApi.hotspots.activate(hotspotsName, timeoutView);
    };

    // hide hotspots
    window.hideHotspots = (hotspotsNames) => {
      if (!viewerApi || !viewerApi.hotspots) return;

      // call api hide hotspot
      hotspotsNames.forEach((hotspotsName) => {
        viewerApi.hotspots.hide(hotspotsName, true);
      });
    };

    return () => {
      // Destroy viewer instance when unmounse
      if (viewerApi) viewerApi.delete();
    };
  }, [dataWedRotate]);

  return (
    <div className="clik-webrotate__container" key="clik-webrotate__container">
      <div id={`clik-webrotate-${code}`} key={`clik-webrotate-${code}`}></div>
      <Loading loading={loading} />
    </div>
  );
};

export default WebRotate;
